import { useEffect } from "react";

// Sets document title + meta description per page. `noindex` adds a
// robots meta for private surfaces (login, analytics, admin).
export function usePageMeta({ title, description, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    let r = document.querySelector('meta[name="robots"][data-page]');
    if (noindex) {
      if (!r) {
        r = document.createElement("meta");
        r.setAttribute("name", "robots");
        r.setAttribute("data-page", "1");
        document.head.appendChild(r);
      }
      r.setAttribute("content", "noindex, nofollow");
    } else if (r) {
      r.remove();
    }
  }, [title, description, noindex]);
}
